import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { sgKeys } from '../queries/keys';
import { sgPaths } from '../queries/paths';

// TSS vite/03 — navegador de vacas físicas SG (GET /admin/sg/cows, admin-sg.md · B1).
// Una fila por vaca cowre, agrupando sus fichas SG. El backend ya garantiza el scope
// (solo conciliadas + activas), así que el front NO filtra por match_state ni ve
// unmatched. Envelope pelado { items, pagination }. Filtros: q (búsqueda que el
// backend normaliza), sg_codfin. Permiso: sg:read (ruta ya gateada en app.jsx).

function clean(filters = {}) {
    const out = {};
    for (const k of ['q', 'sg_codfin', 'limit', 'offset']) {
        const v = filters[k];
        if (v !== '' && v != null) out[k] = v;
    }
    return out;
}

export function useSgCows(filters) {
    const params = clean(filters);
    return useQuery({
        queryKey: sgKeys.cows(params),
        queryFn:  ({ signal }) => api.get(sgPaths.cows(), { params, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}
